import { GroupCardScreenProps } from "./types"
import React, { useState } from "react"
import { observer } from "mobx-react-lite"
import styled, { useTheme } from '~/ui/styled'
import { Text, Button, CenterFlex, ColumnFlex, StartFlex } from "~components/El"
import { Avatar } from "~widgets/avatar"
import useNavigation from "~hooks/useNavigation"
import { useStores } from "~models"
import useGroupActions from "~hooks/useGroupActions"
import { globalToast } from "~utils"
import { DeviceEventEmitter } from "~/ui/primitives"
import { REFRESH_CHANNEL_LIST_EVENT } from "~pages/app-stack/channel-list/constants"

const Container = styled.View`
  flex-direction: column;
  margin-bottom: ${({ theme }) => theme.space.xl};
`

const GroupCard: React.FC<GroupCardScreenProps> = ({ chat }) => {
  const theme = useTheme()
  const navigation = useNavigation()
  const { userStore } = useStores()
  const { handleAddGroupMember, ensureLocalChatWhenJoiningGroup } = useGroupActions()
  const [isLoading, setIsLoading] = useState(false)
  const handleAvatarPress = () => {
    if (chat.image) {
      const images = [{ key: "1", url: chat.image }]
      navigation.navigate("ImageGallery", { images, index: 0 })
    }
  }
 
  // 加入群聊
  const handleAddGroup = () => {
    setIsLoading(true)
    ensureLocalChatWhenJoiningGroup({
      id: Number(chat.id),
      chat_id: String(chat.chat_id),
      title: chat.title,
      image: chat.image,
      isChannel: false,
    })
    handleAddGroupMember({
      chat_id: chat.id,
      chat_cid: chat.chat_id,
      sender_id: chat.sender_id ?? userStore.currentUser.id,
      user_ids: [userStore.currentUser.id],
    }).then(data => {
      setIsLoading(false)
      navigation.goBack()
    }).catch(error => {
      setIsLoading(false)
      globalToast.show(error?.message || "加入群聊失败")
    })
  }

  // 订阅频道
  const handleJoinChannel = () => {
    setIsLoading(true)
    ensureLocalChatWhenJoiningGroup({
      id: Number(chat.id),
      chat_id: String(chat.chat_id),
      title: chat.title,
      image: chat.image,
      isChannel: true,
    })
    handleAddGroupMember({
      chat_id: chat.id,
      chat_cid: chat.chat_id,
      sender_id: chat.sender_id ?? userStore.currentUser.id,
      user_ids: [userStore.currentUser.id],
      chat_type: 2,
    }).then(data => {
      setIsLoading(false)
      DeviceEventEmitter.emit(REFRESH_CHANNEL_LIST_EVENT)
      navigation.goBack()
    }).catch(error => {
      setIsLoading(false)
      globalToast.show(error?.message || "订阅频道失败")
    })
  }

  // console.log(chat, '--chat--')
  return (
    <Container>
      <StartFlex width="100%" padding="10px 12px" mt="10px" bg={theme.colors.blockBackground}>
        <Avatar avatar={chat.image} size={40} name={chat.title} onClick={handleAvatarPress} />
        <ColumnFlex flex={1} ml="10px">
          <Text color={theme.colors.text} fontSize="15px" fontWeight="600">{chat.title}</Text>
          <Text color={theme.colors.secondaryText} fontSize="13px">{chat.memebersCount} {chat.path === "channel" ? "个订阅者" : "名成员"}</Text>
        </ColumnFlex>
      </StartFlex>
      <CenterFlex width="100%" padding="10px 12px" mt="20px">
        {chat.isCurrentUserExistInMembers && (
          <Button
            onClick={chat.path === "channel" ? handleJoinChannel : handleAddGroup}
            width="100%"
            height="40px"
            borderRadius="8px"
            loading={isLoading}
            disabled={isLoading}
            bg={theme.colors.primary} 
          >
            <Text color={theme.colors.textLight} fontSize="14px" fontWeight="600">{chat.path === "channel" ? "订阅频道" : "加入群聊"}</Text>
          </Button>
        )}
        
      </CenterFlex>
  </Container>
  )
}

export default observer(GroupCard)
